import React from 'react';
import TravelForm from './TravelForm';

import Footer from './Footer';



const Home = () => {
    return (
        <div>
            <TravelForm />

            <Footer />


        </div>
    );
};

export default Home;